<template>
	<div class="newsletter-template-item" @click="$emit('click')">
		<div class="template-content">
			<p class="template-title">{{ template.title }}</p>
			<p class="template-description">{{ template.description }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "NewsletterTemplateItem",
	props: {
		template: {
			type: Object,
			required: true
		}
	},
	emits: ['click']
}
</script>

<style scoped lang="scss">
.newsletter-template-item {
	display: flex;
	flex-direction: column;
	border: 1px solid var(--color-border-2);
	border-radius: 13px;
	border-top-right-radius: 0;
	overflow: hidden;
	cursor: pointer;
	transition: all 0.2s;
	background: var(--color-bg-primary-2);
	padding: 16px;
	min-height: 120px;

	&:hover {
		border-color: var(--color-primary);
		box-shadow: 0 4px 12px var(--color-box-shadow-2);
	}
}

.template-content {
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
}

.template-title {
	font-weight: 600;
	font-size: 16px;
	color: var(--color-txt-1);
	margin: 0;
}

.template-description {
	font-weight: 400;
	font-size: 14px;
	color: var(--color-txt-2);
	margin: 0;
	line-height: 1.4;
}

@media (max-width: 720px) {
	.newsletter-template-item {
		min-height: 100px;
	}
}
</style>
